import {
  baseVendorApiSettingsDefaults,
  defaultHttpAgentSettings,
  defaultRateLimitationSettings,
  defaultSessionSettings,
  defaultVendorApiHttpAdvancedSettings,
} from './base';
import type { AzureApiSettingsDefaults } from './types';

export const azureDefaults: AzureApiSettingsDefaults = {
  ...baseVendorApiSettingsDefaults,
  ...defaultHttpAgentSettings,
  ...defaultRateLimitationSettings,
  ...defaultSessionSettings,
  ...defaultVendorApiHttpAdvancedSettings,
  default202DataRetryAfterMs: 200,
  maxConcurrentRequests: 1000,
  enableLegacyTlsRenegotiation: false,
  subscriptionIds: [],
  tenantId: '',
};
